export class Item {
    public itemId: number;
    public name: string;
    public companyId: number;
    public SKU: string;
    public baseSalePrice: number;
    public basePurchasePrice: number;
    public longDescription: string;
    public shortDescription: string;
    public createdBy: number;
    public creationDate: Date;
    public status: number;
    public unitsPerContainer: number;
    public minimumUnitId: number;
    public containerId: number;
    public stock: boolean;
    public barcode: string;
    public containsTax: boolean;
    public itemSubfamilyId: number;
    public loacs: string;
    public itemSATcode: number;
    public itemSATUnitId: number;

    //Carta Porte
    public GROSS_WEIGHT: number;
    public NET_WEIGHT: number;
    public HAZARDOUS_MATERIAL: number;
    public HAZARDOUS_MATERIAL_ID: number;
    public BILL_PACKAGING_ID: number;
    public DIMENSIONS: string;
    public FILE: string;
}

export class ItemGrid extends Item {
    public subFamilyName: string;
    public familyName: string;
}


// WEBPACK FOOTER //
// ./src/app/models/item.ts